
// import React, { useState, useEffect } from "react";
// import CheckInCheckOutPopup from "./CheckInCheckOutPopup";
// import SightseeingPopup from "./SightseeingPopup";
// import MealPopup from "./MealPopup";
// import AddAttractionsPopup from "./AddAttractionsPopup";
// import { useAuth } from "../contexts/authContext";
// import { useLocation } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import {
//   PencilSquareIcon,
//   TrashIcon,
//   BuildingOfficeIcon,
//   MapPinIcon,
//   CakeIcon,
// } from "@heroicons/react/24/outline";
// import { makeAuthenticatedRequest } from "../utils/apiRequest";


// const DayCard = ({ day, onUpdateDay, onDeleteDay }) => {
//   const location = useLocation();
//   const { token, currentUser } = useAuth();
//   const [isEditingDetails, setIsEditingDetails] = useState(false);
//   const [editableType, setEditableType] = useState(day.type);
//   const [editableDate, setEditableDate] = useState(day.date);
//   const [isEditCityPopupOpen, setIsEditCityPopupOpen] = useState(false);
//   const [cityBeingEdited, setCityBeingEdited] = useState(null);
  

//   const [availableCities, setAvailableCities] = useState([]);
//   const [citiesWithActivities, setCitiesWithActivities] = useState(
//     day.citiesWithActivities || []
//   );
//   const [isCityPopupOpen, setIsCityPopupOpen] = useState(false);

//   const [selectedCity, setSelectedCity] = useState("");
//   const [editingCityIndex, setEditingCityIndex] = useState(null);
//   const [editingActivityIndex, setEditingActivityIndex] = useState(null);
//   const [currentPopup, setCurrentPopup] = useState(null); // "checkin", "sightseeing", "meal"
//   useEffect(() => {
//     console.log("Cities with activities for Day:", day.citiesWithActivities);
//   }, [day.citiesWithActivities]);

//   // Fetch cities on component mount
//   useEffect(() => {
//     const fetchCities = async () => {
//       if (!token) {
//         console.error("Authorization token is missing.");
//         return;
//       }
    
//       try {
//         const response = await makeAuthenticatedRequest(
//           "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_cities",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
    
//         if (!response.ok) {
//           throw new Error(`Error fetching cities: ${response.status}`);
//         }
    
//         const data = await response.json();
//         console.log("Fetched Cities Data:", data);
    
//         if (Array.isArray(data.data)) {
//           setAvailableCities(data.data); // Store full city objects
//         } else {
//           console.error("Unexpected city data format:", data);
//         }
//       } catch (error) {
//         console.error("Error fetching cities:", error.message);
//       }
//     };
    

//     fetchCities();
//   }, [token]);
//   const CityPopup = ({ onClose, onAdd, availableCities }) => {
//     const [selectedCity, setSelectedCity] = useState("");

//     const handleAdd = () => {
//       if (!selectedCity) {
//         alert("Please select a city.");
//         return;
//       }
//       onAdd({ city: selectedCity });
//       onClose();
//     };

//     return (
//       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
//         <div className="bg-white p-4 rounded shadow-lg w-96">
//           <h2 className="text-lg font-bold mb-4">Add City</h2>
//           <select
//             value={selectedCity}
//             onChange={(e) => setSelectedCity(e.target.value)}
//             className="w-full p-2 border rounded mb-4"
//           >
//             <option value="">-- Select City --</option>
//             {availableCities.map((city) => (
//               <option key={city.city_id} value={city.city_name}>
//                 {city.city_name}
//               </option>
//             ))}
//           </select>
//           <div className="flex justify-end gap-2">
//             <button
//               onClick={onClose}
//               className="px-4 py-2 bg-gray-300 text-black rounded"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleAdd}
//               className="px-4 py-2 bg-blue-500 text-white rounded"
//             >
//               Add City
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };
//   const handleAddCity = (cityName) => {
//     const selectedCity = availableCities.find(
//       (city) => city.city_name === cityName
//     );
  
//     if (!selectedCity) {
//       alert("Please select a valid city.");
//       return;
//     }
  
//     const newCities = [
//       ...citiesWithActivities,
//       {
//         city: selectedCity.city_name,
//         city_id: selectedCity.city_id,
//         city_description: selectedCity.description,
//         city_image: selectedCity.city_image_path || [], // Include all city images
//         activities: [],
//       },
//     ];
  
//     setCitiesWithActivities(newCities);
//     setSelectedCity(""); // Reset the dropdown
//     onUpdateDay(day.id, newCities);
//   };
  
  
//   const handleAddActivity = (activityType, activityData) => {
//     const updatedCities = [...citiesWithActivities];
//     const city = updatedCities[editingCityIndex];
  
//     if (!city.activities) city.activities = [];
  
//     // Find the existing meal activity if it exists
//     const existingMealIndex = city.activities.findIndex(
//       (activity) => activity.activity_type === "meal" && activity.restaurant_name === activityData.restaurant_name
//     );
  
//     if (existingMealIndex !== -1 && editingActivityIndex === null) {
//       // If the meal already exists and we are not editing the current one, show the duplicate meal alert
//       alert("This meal already exists for the day. Please choose a different meal.");
//       return;
//     }
  
//     // If we're editing an existing activity, update the relevant details
//     if (editingActivityIndex !== null) {
//       city.activities[editingActivityIndex] = {
//         activity_type: activityType,
//         ...activityData,
//       };
//     } else {
//       // Add a new meal if it's a new entry (not in edit mode)
//       city.activities.push({ activity_type: activityType, ...activityData });
//     }
  
//     updatedCities[editingCityIndex] = city;
//     setCitiesWithActivities(updatedCities);
//     onUpdateDay(day.id, updatedCities);
//     setEditingActivityIndex(null);
//     setCurrentPopup(null);
//   };
  
  
//   const handleEditActivity = (activityType, activityIndex, cityIndex) => {
//     setEditingCityIndex(cityIndex);
//     setEditingActivityIndex(activityIndex);
    
//     // Open the correct popup based on activity type
//     if (activityType === "checkin" || activityType === "checkout") {
//       setCurrentPopup("checkin"); // Use the same popup for both checkin and checkout
//     } else if (activityType === "sightseeing") {
//       setCurrentPopup("sightseeing");
//     } else if (activityType === "meal") {
//       setCurrentPopup("meal");
//     }
//   };
  
  

//   const handleDeleteActivity = (activityIndex, cityIndex) => {
//     const updatedCities = [...citiesWithActivities]; // Create a copy of the cities array
//     const city = updatedCities[cityIndex];
  
//     // Remove the activity at the specified index
//     city.activities = city.activities.filter((_, index) => index !== activityIndex);
  
//     // Update the cities array
//     updatedCities[cityIndex] = city;
  
//     // Update the state with the new cities list
//     setCitiesWithActivities(updatedCities);
  
//     // Notify the parent component about the updated data
//     onUpdateDay(day.id, updatedCities);
//   };
  

//   const handleDragEnd = (result) => {
//     const { source, destination } = result;
  
//     if (!destination) return; // If dropped outside, do nothing
  
//     const sourceCityIndex = parseInt(source.droppableId.split("-")[1], 10);
//     const destinationCityIndex = parseInt(destination.droppableId.split("-")[1], 10);
  
//     const updatedCities = [...citiesWithActivities];
  
//     if (sourceCityIndex === destinationCityIndex) {
//       // Reorder activities within the same city
//       const city = updatedCities[sourceCityIndex];
//       const reorderedActivities = Array.from(city.activities);
//       const [movedActivity] = reorderedActivities.splice(source.index, 1);
//       reorderedActivities.splice(destination.index, 0, movedActivity);
//       updatedCities[sourceCityIndex] = { ...city, activities: reorderedActivities };
//     } else {
//       // Move activity between cities
//       const sourceCity = updatedCities[sourceCityIndex];
//       const destinationCity = updatedCities[destinationCityIndex];
//       const sourceActivities = Array.from(sourceCity.activities);
//       const destinationActivities = Array.from(destinationCity.activities);
  
//       const [movedActivity] = sourceActivities.splice(source.index, 1);
//       destinationActivities.splice(destination.index, 0, movedActivity);
  
//       updatedCities[sourceCityIndex] = { ...sourceCity, activities: sourceActivities };
//       updatedCities[destinationCityIndex] = { ...destinationCity, activities: destinationActivities };
//     }
  
//     // Update the state
//     setCitiesWithActivities(updatedCities);
  
//     // Notify parent about the changes
//     onUpdateDay(day.id, updatedCities);
//   };
  


//   return (
//     <div className="p-4 border rounded shadow mb-4 w-2/3">
//      <div className="flex justify-between items-center">
//         <h2 className="text-lg font-bold">Day {day.number}</h2>
//         <button
//           onClick={() => onDeleteDay(day.id)}
//           className="text-red-500 hover:text-red-700"
//           title="Delete Day"
//         >
//           <TrashIcon className="w-6 h-6" />
//         </button>
//       </div>
//       <div className="flex items-center justify-between mb-4">
//         {isEditingDetails ? (
//           <>
//             {/* Editable Type Dropdown */}
//             <div className="flex items-center gap-2">
//               <label className="font-medium">Type:</label>
//               <select
//                 value={editableType}
//                 onChange={(e) => setEditableType(e.target.value)}
//                 className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//               >
//                 <option value="Arrival Day">Arrival Day</option>
//                 <option value="Departure Day">Departure Day</option>
//                 <option value="Rest Day">Rest Day</option>
//                 <option value="Travel Day">Travel Day</option>
//               </select>
//             </div>

//             {/* Editable Date Picker */}
//             <div className="flex items-center gap-2">
//               <label className="font-medium">Date:</label>
//             <input
//   type="date"
//   value={editableDate}
//   onChange={(e) => setEditableDate(e.target.value)}
//   className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//   min={new Date().toISOString().split("T")[0]} // Set minimum date to today
// />

//             </div>

//             {/* Save/Cancel Buttons */}
//             <div className="flex items-center gap-2">
//             <button
//   onClick={() => {
//     onUpdateDay(day.id, citiesWithActivities, {
//       type: editableType, // Pass updated type
//       date: editableDate, // Pass updated date
//     });
//     setIsEditingDetails(false); // Close the editing view
//   }}
//   className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
// >
//   Save
// </button>


//               <button
//                 onClick={() => setIsEditingDetails(false)}
//                 className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
//               >
//                 Cancel
//               </button>
//             </div>
//           </>
//         ) : (
//           <>
//             <div className="flex gap-4 items-center">
//               <p className="text-gray-500">
//                 <strong>Type:</strong> {day.type}
//               </p>
//               <p className="text-gray-500">
//                 <strong>Date:</strong> {day.date}
//               </p>
//               <button
//                 onClick={() => setIsEditingDetails(true)}
//                 className="text-gray-500 hover:text-blue-600"
//               >
//                 <FontAwesomeIcon icon={faEdit} className="w-5 h-5" />
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//       {isCityPopupOpen && (
//         <CityPopup
//           availableCities={availableCities}
//           onClose={() => setIsCityPopupOpen(false)}
//           onAdd={(cityData) => {
//             handleAddCity(cityData.city);
//             setIsCityPopupOpen(false);
//           }}
//         />
//       )}

//       {/* Add City */}
//       {/* Add City Section */}
//       <div className="flex items-center gap-2 mb-4">
//         <select
//           value={selectedCity}
//           onChange={(e) => setSelectedCity(e.target.value)}
//           className="w-1/2 max-w-xs p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           <option value="">-- Select City --</option>
//           {availableCities.map((city) => (
//             <option key={city.city_id} value={city.city_name}>
//               {city.city_name}
//             </option>
//           ))}
//         </select>

//         <button
//           onClick={() => handleAddCity(selectedCity)}
//           className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
//         >
//           Add City
//         </button>
//       </div>

//       {citiesWithActivities.map((cityData, cityIndex) => (
//   <div key={cityIndex} className="mb-4 border p-4 rounded">
//     <h3 className="text-md font-bold mb-2 flex items-center justify-between">
//       {cityData.city}
//       <button
//         onClick={() => {
//           if (
//             window.confirm(
//               `Are you sure you want to delete ${cityData.city}?`
//             )
//           ) {
//             const updatedCities = citiesWithActivities.filter(
//               (_, index) => index !== cityIndex
//             );
//             setCitiesWithActivities(updatedCities);
//             onUpdateDay(day.id, updatedCities);
//           }
//         }}
//         className="p-2 text-red-500 hover:text-red-700"
//       >
//         <TrashIcon className="w-5 h-5" />
//       </button>
//     </h3>

//     {/* Activities */}
//     <DragDropContext onDragEnd={handleDragEnd}>
//   <Droppable droppableId={`city-${cityIndex}`}>
//     {(provided) => (
//       <div
//         {...provided.droppableProps}
//         ref={provided.innerRef}
//         className="activities-container"
//       >
//         {cityData.activities.map((activity, activityIndex) => (
//           <Draggable
//             key={`${activity.activity_type}-${activityIndex}`}
//             draggableId={`${activity.activity_type}-${activityIndex}`}
//             index={activityIndex}
//           >
//             {(provided) => (
//               <div
//                 ref={provided.innerRef}
//                 {...provided.draggableProps}
//                 {...provided.dragHandleProps}
//                 className="flex items-center justify-between p-4 mb-2 bg-gray-50 border rounded-lg shadow-sm"
//               >
//                 {/* Activity Details */}
//                 <div className="flex items-center gap-3">
//                   <span className="text-blue-600">
//                     {activity.activity_type === "checkin" ||
//                     activity.activity_type === "checkout" ? (
//                       <BuildingOfficeIcon className="w-6 h-6" />
//                     ) : activity.activity_type === "sightseeing" ? (
//                       <MapPinIcon className="w-6 h-6" />
//                     ) : (
//                       <CakeIcon className="w-6 h-6" />
//                     )}
//                   </span>
//                   {/* Activity Details */}
//                   <div className="flex flex-wrap gap-2">
//                     <span className="px-3 py-1 text-sm font-medium bg-gray-800 text-white rounded">
//                       {activity.activity_type.replace(/_/g, " ")}
//                     </span>
//                     {activity.activity_type === "checkin" && (
//                       <>
//                         {activity.hotel_name && (
//                           <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                             {activity.hotel_name}
//                           </span>
//                         )}
//                         {activity.mealPlan && (
//                           <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                             {activity.mealPlan}
//                           </span>
//                         )}
//                         {activity.arrangement && (
//                           <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                             {activity.arrangement}
//                           </span>
//                         )}
//                       </>
//                     )}
//                     {activity.activity_type === "checkout" && (
//                       <>
//                         {activity.hotel_name && (
//                           <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                             {activity.hotel_name}
//                           </span>
//                         )}
//                         {activity.arrangement && (
//                           <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                             {activity.arrangement}
//                           </span>
//                         )}
//                       </>
//                     )}
//                     {activity.activity_type === "sightseeing" && (
//                       <>
//                         <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                           {activity.location_name || "N/A"}
//                         </span>
//                         <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                           {activity.arrangement || "N/A"}
//                         </span>
//                       </>
//                     )}
//                     {activity.activity_type === "meal" && (
//                       <>
//                         <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                           {activity.restaurant_name || "N/A"}
//                         </span>
//                         <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                           {activity.meal || "N/A"}
//                         </span>
//                         <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
//                           {activity.arrangement || "N/A"}
//                         </span>
//                       </>
//                     )}
//                   </div>
//                 </div>
//                 {/* Action Buttons */}
//                 <div className="flex items-center gap-2">
//                   <button
//                     onClick={() =>
//                       handleEditActivity(activity.activity_type, activityIndex, cityIndex)
//                     }
//                     className="p-2 text-gray-500 hover:text-blue-600"
//                   >
//                     <PencilSquareIcon className="w-5 h-5" />
//                   </button>
//                   <button
//                     onClick={() => handleDeleteActivity(activityIndex, cityIndex)}
//                     className="p-2 text-gray-500 hover:text-red-600"
//                   >
//                     <TrashIcon className="w-5 h-5" />
//                   </button>
//                 </div>
//               </div>
//             )}
//           </Draggable>
//         ))}
//         {provided.placeholder}
//       </div>
//     )}
//   </Droppable>
// </DragDropContext>

//     {/* Add Activities Buttons */}
//     <div className="flex gap-4 mt-4">
//       <button
//         onClick={() => {
//           setEditingCityIndex(cityIndex);
//           setEditingActivityIndex(null);
//           setCurrentPopup("checkin");
//         }}
//         className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
//       >
//         Add Check-in/Check-out
//       </button>
//      {/*  <button
//         onClick={() => {
//           setEditingCityIndex(cityIndex);
//           setEditingActivityIndex(null);
//           setCurrentPopup("sightseeing");
//         }}
//         className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
//       >
//         Add Sightseeing
//       </button> */}

// {false && (
//   <button
//     onClick={() => {
//       setEditingCityIndex(cityIndex);
//       setEditingActivityIndex(null);
//       setCurrentPopup("sightseeing");
//     }}
//     className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
//   >
//     Add Sightseeing
//   </button>
// )}

//       <button
//   onClick={() => {
//     setEditingCityIndex(cityIndex);
//     setCurrentPopup("addAttractions");
//   }}
//   className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
// >
//   Add Attractions
// </button>

//       <button
//         onClick={() => {
//           setEditingCityIndex(cityIndex);
//           setEditingActivityIndex(null);
//           setCurrentPopup("meal");
//         }}
//         className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
//       >
//         Add Meal
//       </button>
//       <button
//         onClick={() => setIsCityPopupOpen(true)}
//         className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
//       >
//         Add City
//       </button>
//     </div>
//   </div>
// ))}


      

// {currentPopup === "checkin" && (
//   <CheckInCheckOutPopup
//     defaultCity={citiesWithActivities[editingCityIndex]?.city}
//     onClose={() => setCurrentPopup(null)}
//     onAdd={(data) => handleAddActivity(data.activity_type, data)}
//     editData={editingActivityIndex !== null ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex] : null}
//     editMode="edit" // Trigger the edit behavior
//   />
// )}

// {currentPopup === "checkout" && (
//   <CheckInCheckOutPopup
//     defaultCity={citiesWithActivities[editingCityIndex]?.city}
//     onClose={() => setCurrentPopup(null)}
//     onAdd={(data) => handleAddActivity(data.activity_type, data)}
//     editData={editingActivityIndex !== null ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex] : null}
//     editMode="edit" // Trigger the edit behavior for checkout
//   />
// )}



// {/* {currentPopup === "sightseeing" && (
//   <SightseeingPopup
//     city={citiesWithActivities[editingCityIndex]?.city}
//     onClose={() => setCurrentPopup(null)}
//     onAdd={(data) => handleAddActivity("sightseeing", data)}
//     editData={
//       editingActivityIndex !== null
//         ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
//         : null
//     }
//   />
// )} */}

// {currentPopup === "sightseeing" && (
//   <SightseeingPopup
//     city={citiesWithActivities[editingCityIndex]?.city}
//     filteredAttractions={
//       editingActivityIndex !== null
//         ? [citiesWithActivities[editingCityIndex].activities[editingActivityIndex]]
//         : []
//     } // Renamed to 'filteredAttractions'
//     onClose={() => setCurrentPopup(null)}
//     onAdd={(data) => handleAddActivity("sightseeing", data)}
//     editData={
//       editingActivityIndex !== null
//         ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
//         : null
//     }
//   />
// )}



// {currentPopup === "addAttractions" && (
//   <AddAttractionsPopup
//     city={citiesWithActivities[editingCityIndex]?.city}
//     onClose={() => setCurrentPopup(null)}
//     onAdd={(data) => {
//       data.forEach((attraction) => {
//         handleAddActivity("sightseeing", attraction);
//       });
//     }}
//   />
// )}

// {currentPopup === "editAttractions" && (
//   <AddAttractionsPopup
//     city={citiesWithActivities[editingCityIndex]?.city}
//     onClose={() => setCurrentPopup(null)}
//     onAdd={(data) => {
//       data.forEach((attraction) => {
//         handleAddActivity("sightseeing", attraction);
//       });
//     }}
//     editData={
//       citiesWithActivities[editingCityIndex]?.activities.filter(
//         (activity) => activity.activity_type === "sightseeing"
//       ) || []
//     } // Pass existing sightseeing activities for auto-selection
//   />
// )}


// {currentPopup === "meal" && (
//   <MealPopup
//     city={citiesWithActivities[editingCityIndex]?.city} // Pass the currently selected city
//     cities={availableCities.map((city) => ({
//       city_id: city.city_id, // Ensure unique ID
//       city_name: city.city_name, // City name for dropdown
//     }))} // Pass all available cities
//     onClose={() => setCurrentPopup(null)} // Close popup handler
//     onAdd={(data) => handleAddActivity("meal", data)} // Add meal data
//     editData={
//       editingActivityIndex !== null
//         ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
//         : null
//     }
//     // Pass the current restaurant name to the MealPopup
//     restaurantName={
//       editingActivityIndex !== null
//         ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex].restaurant_name
//         : ''
//     }
//   />
// )}

//     </div>
//   );
// };

// export default DayCard;





import React, { useState, useEffect } from "react";
import CheckInCheckOutPopup from "./CheckInCheckOutPopup";
import SightseeingPopup from "./SightseeingPopup";
import MealPopup from "./MealPopup";
import AddAttractionsPopup from "./AddAttractionsPopup";
import LocationPopup from "./LocationPopup";
import { useAuth } from "../contexts/authContext";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import HotelListPopup from "./HotelListPopup";


import {
  PencilSquareIcon,
  TrashIcon,
  BuildingOfficeIcon,
  MapPinIcon,
  CakeIcon,
} from "@heroicons/react/24/outline";
import { makeAuthenticatedRequest } from "../utils/apiRequest";

const DayCard = ({ day, onUpdateDay, onDeleteDay, selectedRoomCategory }) => {
  const location = useLocation();
  const { token, currentUser } = useAuth();
  const [isEditingDetails, setIsEditingDetails] = useState(false);
  const [editableType, setEditableType] = useState(day.type);
  const [editableDate, setEditableDate] = useState(day.date);
  const [isEditCityPopupOpen, setIsEditCityPopupOpen] = useState(false);
  const [cityBeingEdited, setCityBeingEdited] = useState(null);
  
  // Update editableDate when day.date changes from parent
  useEffect(() => {
    setEditableDate(day.date);
  }, [day.date]);
  
  
const[act,saveact]=useState();
useEffect(()=>{
  console.log("act check",act);
},[act]);
  const [availableCities, setAvailableCities] = useState([]);
  const [citiesWithActivities, setCitiesWithActivities] = useState(
    day.citiesWithActivities || []
  );
  const [isCityPopupOpen, setIsCityPopupOpen] = useState(false);

  const [selectedCity, setSelectedCity] = useState("");
  const [editingCityIndex, setEditingCityIndex] = useState(null);
  const [editingActivityIndex, setEditingActivityIndex] = useState(null);
  const [currentPopup, setCurrentPopup] = useState(null); // "checkin", "sightseeing", "meal"
  useEffect(() => {
    console.log("Cities with activities for Day:", day.citiesWithActivities);
  }, [day.citiesWithActivities]);

  

 
  // Fetch cities on component mount
  useEffect(() => {
    const fetchCities = async () => {
      if (!token) {
        console.error("Authorization token is missing.");
        return;
      }
    
      try {
        const response = await makeAuthenticatedRequest(
          "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_cities",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
    
        if (!response.ok) {
          throw new Error(`Error fetching cities: ${response.status}`);
        }
    
        const data = await response.json();
        console.log("Fetched Cities Data:", data);
    
        if (Array.isArray(data.data)) {
          setAvailableCities(data.data); // Store full city objects
        } else {
          console.error("Unexpected city data format:", data);
        }
      } catch (error) {
        console.error("Error fetching cities:", error.message);
      }
    };
    

    fetchCities();
  }, [token]);
  const CityPopup = ({ onClose, onAdd, availableCities }) => {
    const [selectedCity, setSelectedCity] = useState("");

    const handleAdd = () => {
      if (!selectedCity) {
        alert("Please select a city.");
        return;
      }
      onAdd({ city: selectedCity });
      onClose();
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
       <div className="relative bg-white p-4 rounded shadow-lg w-96">
  {/* Close Icon */}
  <button
    onClick={onClose}
    className="absolute top-2 right-2 text-gray-600 hover:text-black "
  >
      ✖ {/* Cross (X) icon */}
  </button>
  
  <h2 className="text-lg font-bold mb-4">Add City</h2>
  
  <select
    value={selectedCity}
    onChange={(e) => setSelectedCity(e.target.value)}
    className="w-full p-2 border rounded mb-4"
  >
    <option value="">-- Select City --</option>
    {availableCities.map((city) => (
      <option key={city.city_id} value={city.city_name}>
        {city.city_name}
      </option>
    ))}
  </select>
  
  <div className="flex justify-center mt-4">
    {/* <button
      onClick={onClose}
      className="px-4 py-2 bg-gray-300 text-black rounded"
    >
      Cancel
    </button> */}
    <button 
    onClick={handleAdd}
    className="px-4 py-2 bg-blue-500 text-white rounded"
  >
    Add City
  </button>
  </div>
</div>

      </div>
    );
  };
  const handleAddCity = (cityName) => {
    const selectedCity = availableCities.find(
      (city) => city.city_name === cityName
    );
  
    if (!selectedCity) {
      alert("Please select a valid city.");
      return;
    }
  
    const newCities = [
      ...citiesWithActivities,
      {
        city: selectedCity.city_name,
        city_id: selectedCity.city_id,
        city_description: selectedCity.description,
        city_image: selectedCity.city_image_path || [], // Include all city images
        activities: [],
      },
    ];
  
    setCitiesWithActivities(newCities);
    setSelectedCity(""); // Reset the dropdown
    onUpdateDay(day.id, newCities);
  };
  
  
//   const handleAddActivity = (activityType, activityData) => {
//   const updatedCities = [...citiesWithActivities];
//   console.log("updated cities with act", updatedCities);
//   const city = updatedCities[editingCityIndex];

//   if (!city.activities) city.activities = [];

//   // Check for duplicate meal type
//   if (activityType === "meal") {
//     const duplicateMeal = city.activities.some(
//       (activity) =>
//         activity.activity_type === "meal" &&
//         activity.restaurant_name === activityData.restaurant_name &&
//         activity.meal === activityData.meal
//     );
//     if (duplicateMeal) {
//       alert("This meal already exists for the day. Please choose a different meal.");
//       return;
//     }
//   }
  

//   if (editingActivityIndex !== null) {
//     city.activities[editingActivityIndex] = {
//       activity_type: activityType,
//       ...activityData,
//     };
//   } else {
//     city.activities.push({ activity_type: activityType, ...activityData });
//   }

//   updatedCities[editingCityIndex] = city;
//   setCitiesWithActivities(updatedCities);
//   onUpdateDay(day.id, updatedCities);
//   setEditingActivityIndex(null);
//   setCurrentPopup(null);
// };
const handleAddActivity = (activityType, activityData) => {
  if (!Array.isArray(activityData)) {
    activityData = [activityData];
  }

  setCitiesWithActivities((prevCities) => {
    const updatedCities = prevCities.map((city, index) => {
      if (index === editingCityIndex) {
        let updatedActivities = [...city.activities];

        const newActivities = activityData.map((act) => ({
          activity_type: act.activity_type || "sightseeing", // Default to sightseeing if undefined
          ...act,
        }));

        if (editingActivityIndex !== null) {
          // Update the existing activity instead of adding a new one
          updatedActivities[editingActivityIndex] = {
            ...updatedActivities[editingActivityIndex],
            ...newActivities[0], // Update only the fields from new activity data
          };
        } else {
          // Add the new activities
          updatedActivities = [...updatedActivities, ...newActivities];
        }

        return { ...city, activities: updatedActivities };
      }
      return city;
    });

    onUpdateDay(day.id, updatedCities);  // Ensure function is used
    return updatedCities;
  });

  setEditingActivityIndex(null);
  setCurrentPopup(null);
};



  
const handleEditActivity = (activityType, activityIndex, cityIndex) => {
  setEditingCityIndex(cityIndex);
  setEditingActivityIndex(activityIndex);

  // Determine which popup to open
  if (activityType === "checkin" || activityType === "checkout") {
    setCurrentPopup("checkin"); // Use the same popup for both checkin and checkout
  } else if (activityType === "sightseeing") {
    setCurrentPopup("sightseeing");
  } else if (activityType === "meal") {
    setCurrentPopup("meal");
  } else if (activityType === "location") {
    setCurrentPopup("location");
  }
};



  const handleDeleteActivity = (activityIndex, cityIndex) => {
    const updatedCities = [...citiesWithActivities]; // Create a copy of the cities array
    const city = updatedCities[cityIndex];
  
    // Remove the activity at the specified index
    city.activities = city.activities.filter((_, index) => index !== activityIndex);
  
    // Update the cities array
    updatedCities[cityIndex] = city;
  
    // Update the state with the new cities list
    setCitiesWithActivities(updatedCities);
  
    // Notify the parent component about the updated data
    onUpdateDay(day.id, updatedCities);
  };
  

  const handleDragEnd = (result) => {
    const { source, destination } = result;
  
    if (!destination) return; // If dropped outside, do nothing
  
    const sourceCityIndex = parseInt(source.droppableId.split("-")[1], 10);
    const destinationCityIndex = parseInt(destination.droppableId.split("-")[1], 10);
  
    const updatedCities = [...citiesWithActivities];
  
    if (sourceCityIndex === destinationCityIndex) {
      // Reorder activities within the same city
      const city = updatedCities[sourceCityIndex];
      const reorderedActivities = Array.from(city.activities);
      const [movedActivity] = reorderedActivities.splice(source.index, 1);
      reorderedActivities.splice(destination.index, 0, movedActivity);
      updatedCities[sourceCityIndex] = { ...city, activities: reorderedActivities };
    } else {
      // Move activity between cities
      const sourceCity = updatedCities[sourceCityIndex];
      const destinationCity = updatedCities[destinationCityIndex];
      const sourceActivities = Array.from(sourceCity.activities);
      const destinationActivities = Array.from(destinationCity.activities);
  
      const [movedActivity] = sourceActivities.splice(source.index, 1);
      destinationActivities.splice(destination.index, 0, movedActivity);
  
      updatedCities[sourceCityIndex] = { ...sourceCity, activities: sourceActivities };
      updatedCities[destinationCityIndex] = { ...destinationCity, activities: destinationActivities };
    }
  
    // Update the state
    setCitiesWithActivities(updatedCities);
  
    // Notify parent about the changes
    onUpdateDay(day.id, updatedCities);
  };
  
  useEffect(() => {
    setCitiesWithActivities(day.citiesWithActivities || []);
  }, [day.citiesWithActivities]);

  const [isHotelPopupOpen, setIsHotelPopupOpen] = useState(false);
  const [selectedHotelCity, setSelectedHotelCity] = useState("");

  

  return (
    <div className="p-4 border rounded shadow mb-4 w-2/3">
     <div className="flex justify-between items-center">
        <h2 className="text-lg font-bold">Day {day.number}</h2>
        <button
          onClick={() => onDeleteDay(day.id)}
          className="text-red-500 hover:text-red-700"
          title="Delete Day"
        >
          <TrashIcon className="w-6 h-6" />
        </button>
      </div>
      <div className="flex items-center justify-between mb-4">
        {isEditingDetails ? (
          <>
            {/* Editable Type Dropdown */}
            <div className="flex items-center gap-2">
              <label className="font-medium">Type:</label>
              <select
                value={editableType}
                onChange={(e) => setEditableType(e.target.value)}
                className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="Arrival Day">Arrival Day</option>
                <option value="Departure Day">Departure Day</option>
                <option value="Rest Day">Rest Day</option>
                <option value="Travel Day">Travel Day</option>
              </select>
            </div>

            {/* Editable Date Picker */}
            <div className="flex items-center gap-2">
              <label className="font-medium">Date:</label>
            <input
  type="date"
  value={editableDate}
  onChange={(e) => setEditableDate(e.target.value)}
  className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
  min={new Date().toISOString().split("T")[0]} // Set minimum date to today
/>

            </div>

            {/* Save/Cancel Buttons */}
            <div className="flex items-center gap-2">
            <button
  onClick={() => {
    // Create an object with the updated details
    const updatedDetails = {
      type: editableType,
      date: editableDate,
      autoUpdateDates: true, // Flag to indicate dates should be auto-updated
      dayNumber: day.number // Pass the day number for relative date calculation
    };
    
    onUpdateDay(day.id, citiesWithActivities, updatedDetails);
    setIsEditingDetails(false); // Close the editing view
  }}
  className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
>
  Save
</button>


              <button
                onClick={() => setIsEditingDetails(false)}
                className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Cancel
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="flex gap-4 items-center">
              <p className="text-gray-500">
                <strong>Type:</strong> {day.type}
              </p>
              <p className="text-gray-500">
                <strong>Date:</strong> {day.date}
              </p>
              <button
                onClick={() => setIsEditingDetails(true)}
                className="text-gray-500 hover:text-blue-600"
              >
                <FontAwesomeIcon icon={faEdit} className="w-5 h-5" />
              </button>
            </div>
          </>
        )}
      </div>
      {isCityPopupOpen && (
        <CityPopup
          availableCities={availableCities}
          onClose={() => setIsCityPopupOpen(false)}
          onAdd={(cityData) => {
            handleAddCity(cityData.city);
            setIsCityPopupOpen(false);
          }}
        />
      )}

   
      {/* Add City Section */}
      <div className="flex items-center gap-2 mb-4">
        <select
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
          className="w-1/2 max-w-xs p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">-- Select City --</option>
          {availableCities.map((city) => (
            <option key={city.city_id} value={city.city_name}>
              {city.city_name}
            </option>
          ))}
        </select>

        <button
          onClick={() => handleAddCity(selectedCity)}
          className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 text-lg-"
        >
          Add City
        </button>
      </div>

      {citiesWithActivities.map((cityData, cityIndex) => (
  <div key={cityIndex} className="mb-4 border p-4 rounded">
    <h3 className="text-md font-bold mb-2 flex items-center justify-between">
      {cityData.city}
      <button
        onClick={() => {
          if (
            window.confirm(
              `Are you sure you want to delete ${cityData.city}?`
            )
          ) {
            const updatedCities = citiesWithActivities.filter(
              (_, index) => index !== cityIndex
            );
            setCitiesWithActivities(updatedCities);
            onUpdateDay(day.id, updatedCities);
          }
        }}
        className="p-2 text-red-500 hover:text-red-700"
      >
        <TrashIcon className="w-5 h-5" />
      </button>
    </h3>

    {/* Activities */}
    <DragDropContext onDragEnd={handleDragEnd}>
  <Droppable droppableId={`city-${cityIndex}`}>
    {(provided) => (
      <div
        {...provided.droppableProps}
        ref={provided.innerRef}
        className="activities-container"
      >
        {cityData.activities.map((activity, activityIndex) => (
          <Draggable
            key={`${activity.activity_type}-${activityIndex}`}
            draggableId={`${activity.activity_type}-${activityIndex}`}
            index={activityIndex}
          >
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className="flex items-center justify-between p-4 mb-2 bg-gray-50 border rounded-lg shadow-sm"
              >
                {/* Activity Details */}
                <div className="flex items-center gap-3">
                  <span className="text-blue-600">
                    {activity.activity_type === "checkin" ||
                    activity.activity_type === "checkout" ? (
                      <BuildingOfficeIcon className="w-6 h-6" />
                    ) : activity.activity_type === "sightseeing" ? (
                      <MapPinIcon className="w-6 h-6" />
                    ) : (
                      <CakeIcon className="w-6 h-6" />
                    )}
                  </span>
                  {/* Activity Details */}
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 text-sm font-medium bg-gray-800 text-white rounded">
                      {activity.activity_type.replace(/_/g, " ")}
                    </span>
                    {activity.activity_type === "checkin" && (
                      <>
                        {activity.hotel_name && (
                          <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                            {activity.hotel_name}
                          </span>
                        )}
                        {activity.mealPlan && (
                          <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                            {activity.mealPlan}
                          </span>
                        )}

{console.log("Room Type in Activity:", activity.roomType)}  {/* Log room type */}
                          
                         {activity.roomType && (
                          <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                            {activity.roomType}
                          </span>
                        )}
                        {/* {activity.arrangement && (
                          <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                            {activity.arrangement}
                          </span>
                        )} */}
                      </>
                    )}
                    {activity.activity_type === "checkout" && (
                      <>
                        {activity.hotel_name && (
                          <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                            {activity.hotel_name}
                          </span>
                        )}
                        {/* {activity.arrangement && (
                          <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                            {activity.arrangement}
                          </span>
                        )} */}
                      </>
                    )}
                    {/* {activity.activity_type == "sightseeing" && (
                      <>
                      <button
                      onClick={()=>saveact(activity)}
                      >click</button>
                        <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                          {activity.location_name || "N/A"}
                        </span>
                        <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                          {activity.arrangement || "N/A"}
                        </span>
                      </>
                    )} */}
                    
                    {/* {activity.activity_type === "sightseeing" && (
              <>
                <button onClick={() => saveact(activity)}>click</button>
                
                {Object.keys(activity).map((key) => {
                  if (!isNaN(key)) { // Ensure key is a number (i.e., a location)
                    const location = activity[key]; // Access location object

        return (
          <div key={location.location_id} className="mb-2">
            <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
              {location.location_name || "N/A"}
            </span>
            <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
              {location.arrangement || "N/A"}
            </span>
          </div>
        );
      }
      return null;
    })}
  </>
)} */}

{/* {activity.activity_type === "sightseeing" && (
  <>
  <button
                      onClick={()=>saveact(activity)}
                      >click</button>
    <div className="mt-2">
      {Object.entries(activity)
        .filter(([key, value]) => !isNaN(key) && typeof value === "object") // Process only numeric keys
        .map(([key, location]) => (
          <div key={location.location_id} className="mt-1">
            <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
              {location.location_name || "N/A"}
            </span>
            <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
              {location.arrangement || "N/A"}
            </span>
          </div>
        ))}
    </div>
  </>
)} */}

{/* {activity.activity_type === "location" && (
  <div className="flex items-center gap-2">
    <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
      {activity.location_name || "N/A"}
    </span>
    <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
      {activity.arrangement || "N/A"}
    </span>
  </div>
)}

{activity.activity_type === "location" && (
  console.log("Location Name1:", activity.location_name || "N/A"),
  console.log("Arrangement1:", activity.arrangement || "N/A")
)} */}



{/* {activity.activity_type === "sightseeing" && (
  <>
    <div className="align-middle flex flex-wrap gap-2">
      {Object.entries(activity)
        .filter(([key, value]) => !isNaN(key) && typeof value === "object")
        .map(([key, location]) => {
          // Log the location details to the console
          console.log("Location ID:", location.location_id);
          console.log("Location Name2:", location.location_name || "N/A");
          console.log("Arrangement2:", location.arrangement || "N/A");

          return (
            <div key={location.location_id} className="mt-1">
              <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                {location.location_name || "N/A"}
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                {location.arrangement || "N/A"}
              </span>
            </div>
          );
        })}
    </div>
  </>
)} */}


{/* Add Sightseeing, Add Attraction , Add Location*/}


{activity.activity_type === "sightseeing" && (
  <>
    <div className="align-middle flex flex-wrap gap-2 ">
      {activity.location_name && (
        <>
          <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
            {activity.location_name}
          </span>
          {console.log("Location Name3:", activity.location_name)} {/* Printing location name */}
        </>
      )}
      {/* {activity.arrangement && (
        <>
          <span className="px-3   py-1 text-xs font-medium bg-gray-200 rounded">
            {activity.arrangement}
          </span>
          {console.log("Arrangement3:", activity.arrangement)} 
        </>
      )} */}
    </div>
  </>
)}
{activity.activity_type === "meal" && (
                      <>
                        <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                          {activity.restaurant_name || "N/A"}
                        </span>
                        <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                          {activity.meal || "N/A"}
                        </span>
                        {/* <span className="px-3 py-1 text-xs font-medium bg-gray-200 rounded">
                          {activity.arrangement || "N/A"}
                        </span> */}
                      </>
                    )}
                  </div>
                </div>
                {/* Action Buttons */}
                <div className="flex items-center gap-2">
                  <button
                    onClick={() =>
                      handleEditActivity(activity.activity_type, activityIndex, cityIndex)
                    }
                    className="p-2 text-gray-500 hover:text-blue-600"
                  >
                    <PencilSquareIcon className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => handleDeleteActivity(activityIndex, cityIndex)}
                    className="p-2 text-gray-500 hover:text-red-600"
                  >
                    <TrashIcon className="w-5 h-5" />
                  </button>
                </div>
              </div>
            )}
          </Draggable>
        ))}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
</DragDropContext>

    {/* Add Activities Buttons */}
    <div className="flex gap-4 mt-4">
      <button
        onClick={() => {
          setEditingCityIndex(cityIndex);
          setEditingActivityIndex(null);
          setCurrentPopup("checkin");
        }}
        className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-colors"
      >
     Check-in/Check-out
      </button>

      <button

  onClick={() => {
    setEditingCityIndex(cityIndex);
    setEditingActivityIndex(null);
    setCurrentPopup("location")}
  }
  className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-colors"
>
  Quick Sightseeing
</button>

     <button
        onClick={() => {
          setEditingCityIndex(cityIndex);
          setEditingActivityIndex(null);
          setCurrentPopup("sightseeing");
        }}
        className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-colors"
      >
      Sightseeing
      </button> 
 
{false && (
  <button
    onClick={() => {
      setEditingCityIndex(cityIndex);
      setEditingActivityIndex(null);
      setCurrentPopup("sightseeing");
    }}
    className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-colors"
  >
    Sightseeing
  </button>
)}
 
      {/* <button
  onClick={() => {
    setEditingCityIndex(cityIndex);
    setCurrentPopup("addAttractions");
  }}
  className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 transition-colors"
>
  Add Attractions
</button> */}




      <button
        onClick={() => {
          setEditingCityIndex(cityIndex);
          setEditingActivityIndex(null);
          setCurrentPopup("meal");
        }}
        className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-colors"
      >
         Meal
      </button>

      <button
        onClick={() => setIsCityPopupOpen(true)}
        className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-colors"
      >
       City
      </button>

      {/* <button
  onClick={() => {
    setSelectedHotelCity(citiesWithActivities[cityIndex]?.city);
    setIsHotelPopupOpen(true);
  }}
  className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600 transition-colors"
>
  Hotel
</button> */}

    </div>
  </div>
))}

{isHotelPopupOpen && (
  <HotelListPopup
    city={selectedHotelCity}
    onClose={() => setIsHotelPopupOpen(false)}
  />
)}

      

{currentPopup === "checkin" && (
  <CheckInCheckOutPopup
    defaultCity={citiesWithActivities[editingCityIndex]?.city}
    onClose={() => setCurrentPopup(null)}
    onAdd={(data) => handleAddActivity(data.activity_type, data)}
    editData={
      editingActivityIndex !== null
        ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
        : null
    }
    editMode={
      editingActivityIndex !== null
        ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
            .activity_type
        : null
    }
    popupTitle={
      editingActivityIndex !== null &&
      citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
        .activity_type === "checkin"
        ? "Edit Checkin"
        : editingActivityIndex !== null &&
          citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
            .activity_type === "checkout"
        ? "Edit Checkout"
        : "Add Check-in/Check-out"
    }
    selectedRoomCategory={selectedRoomCategory}  // Pass selectedRoomCategory to the popup
  />
)}

{/* Add Sightseeing */}

{currentPopup === "sightseeing" && (
  <>
    {console.log("Current Popup:", currentPopup)}
    {console.log("City:", citiesWithActivities[editingCityIndex]?.city)}
    {console.log("Edit Data S:", editingActivityIndex !== null 
      ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
      : null)}

<SightseeingPopup
  city={citiesWithActivities[editingCityIndex]?.city}
  filteredAttractions={editingActivityIndex !== null 
    ? [citiesWithActivities[editingCityIndex].activities[editingActivityIndex]]
    : []}
  onClose={() => setCurrentPopup(null)}
  onAdd={(data) => handleAddActivity("sightseeing", data)}
  editData={editingActivityIndex !== null 
    ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
    : null} // Pass the entire editData for proper handling of ticket info
/>

  </>
)}


{/* {currentPopup === "sightseeing" && (
  <>
    {console.log("City:", citiesWithActivities[editingCityIndex]?.city)}
    {console.log("Filtered Attractions:", 
      editingActivityIndex !== null
        ? [citiesWithActivities[editingCityIndex].activities[editingActivityIndex]]
        : []
    )}
    {console.log("Edit Data Si:", 
      editingActivityIndex !== null
        ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
        : null
    )}
    
    <SightseeingPopup
  city={citiesWithActivities[editingCityIndex]?.city}
  filteredAttractions={editingActivityIndex !== null 
    ? [citiesWithActivities[editingCityIndex].activities[editingActivityIndex]]
    : []}
  onClose={() => setCurrentPopup(null)}
  onAdd={(data) => handleAddActivity("sightseeing", data)}
  editData={editingActivityIndex !== null 
    ? citiesWithActivities[editingCityIndex].activities[editingActivityIndex]
    : null} // Pass the entire editData for proper handling of ticket info
/>

  </>
)} */}

{/* Add Attraction */}

{/* {currentPopup === "addAttractions" && (
  <AddAttractionsPopup
    city={citiesWithActivities[editingCityIndex]?.city}
    onClose={() => setCurrentPopup(null)}
    onAdd={(data) => {
      console.log("Attractions Data: ", data); // This will log the data to the console
      data.forEach((attraction) => {
        console.log("Adding attraction: ", attraction); // Log each attraction being added
        handleAddActivity("sightseeing", attraction);
      });
    }}
  />
)} */}


{/* {currentPopup === "editAttractions" && (
  <AddAttractionsPopup
    city={citiesWithActivities[editingCityIndex]?.city}
    onClose={() => {
      console.log("Popup closed");
      setCurrentPopup(null);
    }}
    onAdd={(data) => {
      console.log("Data to be added:", data); // Logs the data being added
      data.forEach((attraction) => {
        console.log("Attraction being added:", attraction); // Logs each attraction
        handleAddActivity("sightseeing", attraction);
      });
    }}
    editData={
      citiesWithActivities[editingCityIndex]?.activities.filter(
        (activity) => activity.activity_type === "sightseeing"
      ) || []
    } // Pass existing sightseeing activities for auto-selection
  />
)} */}


{/* Add Location */}
 
{currentPopup === "location" && (
  <LocationPopup
    token={token}
    onClose={() => setCurrentPopup(null)}
    onAdd={(selectedLocations) => {
      handleAddActivity("location", selectedLocations);
      console.log("Selected Location", selectedLocations); // This will log the selected locations
    }}
  />
)}
 {currentPopup === "meal" && (
        <MealPopup
          city={citiesWithActivities[editingCityIndex]?.city} // Pass the currently selected city
          cities={availableCities.map((city) => ({
            city_id: city.city_id, // Ensure unique ID
            city_name: city.city_name, // City name for dropdown
          }))} // Pass all available cities
          onClose={() => setCurrentPopup(null)} // Close popup handler
          onAdd={(data) => handleAddActivity("meal", data)} // Add meal data
          editData={
            editingActivityIndex !== null
              ? citiesWithActivities[editingCityIndex].activities[
                  editingActivityIndex
                ]
              : null
          }
        />
      )}
    </div>
  );
};

export default DayCard;